import { connect } from '@atlassian/jira-react-redux';
import { mapStateToProps } from './query';

import { CtpOnboardingPlanDataSubscriber } from './view';

export default connect(mapStateToProps, {})(CtpOnboardingPlanDataSubscriber);
